import React from "react"
import redirectImage from "../../../../public/images/redirect-to-app.svg"
import IOSIcon from "../../../../public/images/IOS_btn.svg";

const MobileRedirectToApp = () => {
    return (
        <div style={{
            padding: "40px",
            textAlign: "center",
            backgroundColor: "#FFFFFF",
            minHeight: "90vh",
            maxHeight: "-webkit-fill-available"
        }}>
            <img id={"app-logo"} src="images/surveyheart1.png" alt={"SurveyHeart"} style={{width: "100%"}}/>
            <p style={{fontSize: "20px"}}>
                Create powerful surveys in minutes with <span style={{color: "#1976D2"}}>SurveyHeart.</span>
            </p>
            <img src={redirectImage} alt={"image"} style={{margin: "20px 0", width: "100%"}}/>
            <p style={{fontSize: "20px"}}>Enjoy the best experience! Download our mobile app now.</p>
            <div style={{display: "block"}}>
                <a href='https://play.google.com/store/apps/details?id=com.surveyheart&referrer=internal_mobile_webapp'>
                    <img alt='Get it on Google Play'
                         id="download-image"
                         style={{width: "220px"}}
                         src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png'/>
                </a>
                <a href='https://apps.apple.com/us/app/surveyheart-online-form-maker/id6443449067?itsct=apps_box_badge&amp;itscg=30200%22'>
                    <img alt='Get it on App Store'
                         id="ios-download-image"
                         style={{width: "190px"}}
                         src={IOSIcon}/>
                </a>
            </div>
        </div>
    )
}

export default MobileRedirectToApp
